module.exports = __webpack_public_path__ + "img/features-support-03.537b26c4.jpg";